export default __webpack_public_path__ + "static/media/vbb-mentee-computer.a8420ce5.png";